import {createRule, type Maybe} from '@regle/core';
import {isFilled} from '@regle/rules';
import {useTranslation} from '#imports';
import {getVatNumberExampleByCountry, validateVat} from './vatNumber.validator';

/** Check if a VAT number is valid for the country provided
 *  Validate a VAT number depending on the country provided
 *
 * @param countryCode the country related to the VAT number
 */
export const vatNumber = createRule({
    type: 'vatNumber',
    validator: (value: Maybe<string>, countryCode: string) => {
        if (isFilled(value)) {
            return validateVat(value, countryCode);
        }
        return true;
    },
    message({$params: [countryCode]}) {
        const {t} = useTranslation();
        const vatExample = getVatNumberExampleByCountry(countryCode);
        return t('generic.forms.validation.errors.vatNumber', [vatExample ? `(ex: ${vatExample})` : '']);
    },
});
